import { useApolloClient } from "@apollo/client";
import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { getActiveProvider } from "shared/auth/providers";
import Loading from "shared/components/Spin";
import { StoreContext } from "shared/store";
import { SCREENS } from "utils/constants";

const Logout = () => {
  const { clearStore } = useContext(StoreContext);
  const navigate = useNavigate();
  const client = useApolloClient();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (hasLoggedOut.current) return;
    hasLoggedOut.current = true;

    const logout = async () => {
      // Delegate to the active provider. Each provider drops the user from React
      // state first (so auth-gated queries like UnreadNotificationsCount stop
      // firing), then tears down its session and clears the Apollo cache without
      // refetching.
      await getActiveProvider().logout({ clearStore, client });
      navigate(SCREENS.AUTH.SIGN_IN.path, { replace: true });
    };
    logout();
  }, [clearStore, navigate, client]);

  return (
    <div>
      <Loading />
    </div>
  );
};

export default Logout;
